import { render, staticRenderFns } from "./vOrderListItem.vue?vue&type=template&id=95051dcc&"
import script from "./vOrderListItem.vue?vue&type=script&lang=js&"
export * from "./vOrderListItem.vue?vue&type=script&lang=js&"
import style0 from "./vOrderListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports